import React from 'react';
import { Box, Checkbox, Typography, IconButton, Collapse } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import ProdutoDetalhes from '../../components/ProdutoDetalhes';

type ProdutoItemProps = {
  produto: any;
  onSelecionar: (uuid: string) => void;
  onExpandir: (uuid: string) => void;
  onChange: (uuid: string, campo: string, valor: any) => void;
  focusedFieldRef: React.MutableRefObject<any> | null;
};

export default React.memo(function ProdutoItem({ produto, onSelecionar, onExpandir, onChange, focusedFieldRef }: ProdutoItemProps) {
  return (
    <Box mb={1}>
      <Box
        display="flex"
        alignItems="center"
        sx={{
          p: 1,
          backgroundColor: produto.selecionado ? '#f5f5f5' : 'transparent',
          cursor: 'pointer',
          border: '1px solid #ddd',
          borderRadius: 1
        }}
      >
        <Checkbox
          checked={produto.selecionado}
          onChange={() => onSelecionar(produto.uuid)}
          onMouseDown={(e) => e.preventDefault()}
          size="small"
        />
        <Typography
          flexGrow={1}
          onClick={() => onSelecionar(produto.uuid)}
          variant="body2"
        >
          {produto.name}
        </Typography>
        {produto.selecionado && (
          <IconButton
            onClick={() => onExpandir(produto.uuid)}
            onMouseDown={(e) => e.preventDefault()}
            size="small"
          >
            {produto.expandido ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        )}
      </Box>

      <Collapse in={produto.selecionado && produto.expandido} unmountOnExit>
        <ProdutoDetalhes produto={produto} onChange={onChange} focusedFieldRef={focusedFieldRef} />
      </Collapse>
    </Box>
  );
});
